import { useIntl } from 'react-intl';
import Button from '../button/Button';

interface ClearNotificationsProps {
  handleClearAllModalCancel: () => void;
  handleClearAll: () => void;
}

const ClearNotifications = ({
  handleClearAllModalCancel,
  handleClearAll
}: ClearNotificationsProps) => {
  const intl = useIntl();
  return (
    <div className="b-primary0 md:min-w-500 rounded-3xl p-5 md:max-w-500">
      <div className="mb-5 mt-10 rounded-2xl bg-theme p-4">
        {intl.formatMessage({
          id: 'confirmations.doYouWantToClearAllNotifications'
        })}
      </div>
      <div className="flex items-center justify-end gap-2">
        <Button
          label={intl.formatMessage({
            id: 'actions.cancel'
          })}
          variant="secondary"
          size="small"
          handleClick={handleClearAllModalCancel}
        />
        <Button
          label={intl.formatMessage({
            id: 'actions.clearAll'
          })}
          size="small"
          handleClick={handleClearAll}
        />
      </div>
    </div>
  );
};

export default ClearNotifications;
